import React from 'react';
import './css/CommandsList.css';

const CommandsList = () => {
  const commandCategories = [
    {
      title: "🛠️ Основные команды",
      commands: [
        { name: "/help", description: "Показывает команды бота" },
        { name: "/bot", description: "Информация о боте" },
        { name: "/eightball", description: "Задайте вопрос и получите ответ" }
      ]
    },
    {
      title: "👮‍♂️ Модерация",
      commands: [
        { name: "/ban", description: "Заблокировать пользователя на сервере" },
        { name: "/kick", description: "Выгнать участника из сервера" },
        { name: "/mute", description: "Замутить пользователя" }
      ]
    },
    {
      title: "🎵 Музыка",
      commands: [
        { name: "/play", description: "Воспроизвести музыку по URL или названию" },
        { name: "/skip", description: "Пропустить текущий трек" },
        { name: "/volume", description: "Установить громкость" }
      ]
    }
  ];

  return (
    <section className="commands-section" id="commands">
      <h2>Команды бота</h2>
      <div className="commands-grid">
        {commandCategories.map((category, index) => (
          <div key={index} className="command-category">
            <h3>{category.title}</h3>
            <div className="commands-list">
              {category.commands.map((command, cmdIndex) => (
                <div key={cmdIndex} className="command-item">
                  <span className="command-name">{command.name}</span>
                  <span className="command-description">{command.description}</span>
                </div>
              ))}
            </div>
          </div>
        ))}
      </div>
    </section>
  );
};

export default CommandsList;